import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Reveal, Overline } from "@/components/Reveal";
import EpisodeCard from "@/components/EpisodeCard";
import { api } from "@/lib/api";

export default function LatestPrograms() {
  const [episodes, setEpisodes] = useState(null);

  useEffect(() => {
    api.get("/episodes").then((r) => setEpisodes(r.episodes)).catch(() => setEpisodes([]));
  }, []);

  const hasPrograms = episodes && episodes.length > 0;

  return (
    <section data-testid="latest-programs-section" className="py-20 md:py-24">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <Reveal className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <Overline>The Archive</Overline>
            <h2 className="mt-4 font-display text-4xl font-black leading-[0.92] tracking-tight md:text-6xl">
              Every episode, <span className="italic text-gold">on record.</span>
            </h2>
          </div>
          <Link
            to="/episodes"
            data-testid="latest-programs-archive-link"
            className="rounded-full border border-gold/50 px-6 py-3 text-sm font-semibold text-gold transition-colors hover:bg-gold hover:text-ink"
          >
            Full Archive &rarr;
          </Link>
        </Reveal>

        {hasPrograms ? (
          <div className="mt-16 grid gap-6 md:grid-cols-3">
            {episodes.slice(0, 3).map((ep, i) => (
              <Reveal key={ep.slug} delay={i * 0.1}>
                <EpisodeCard episode={ep} />
              </Reveal>
            ))}
          </div>
        ) : (
          <Reveal delay={0.1} className="mt-14">
            <Link
              to="/episodes"
              data-testid="latest-programs-empty"
              className="group flex flex-col items-start justify-between gap-6 rounded-3xl border border-corduroy bg-cocoa p-8 transition-colors hover:border-gold/50 md:flex-row md:items-center md:p-12"
            >
              <p className="max-w-xl font-editorial text-2xl italic leading-snug text-cream/85 md:text-3xl">
                <span className="text-gold">Program 001</span> lands December 3.
                After that, catch up here.
              </p>
              <span className="whitespace-nowrap font-sans text-[11px] font-bold uppercase tracking-[0.24em] text-gold transition-opacity group-hover:opacity-70">
                See the Shows &rarr;
              </span>
            </Link>
          </Reveal>
        )}
      </div>
    </section>
  );
}
